// Vue
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

@Component({
    mixins: [
        template,
    ]
})
export class HeaderFlyout extends Vue {

    @Prop()
    public value!: string

    @Prop({type: Object})
    public item!: any

    @Prop({default: 'default'})
    public size!: string

    public created () {
        window.addEventListener('click', this.closeFlyout)
    }

    public destroyed() {
        window.removeEventListener('click', this.closeFlyout)
    }

    public get flyoutSize() {
        if( this.size === 'full' ) {
            return `${this.$appPrefix}-header-flyout-size--full`
        } else {
            return `${this.$appPrefix}-header-flyout-size--default`
        }
    }


    public closeFlyout(e: any) {

        if (this.item.id != this.value) return

        if (!e || e.target.contains(this.$el) || !this.$el.contains(e.target)) {
            this.$emit('close-flyout')
        }
    }
}